/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoggerInterface } from './loggerInterface';
import { LogSeverity } from './logSeverity';

export class ConsoleLogger implements LoggerInterface {
    private prefix: string = 'GLOBAL';

    public log = (severity: LogSeverity, ...inArgs: any[]) => {
        const prefix = this.getPrefix(severity);
        const severityStyle = this.getSeverityStyleString(severity);

        const args = [severityStyle, ...inArgs];

        if (severity === LogSeverity.ERROR) {
            console.error(prefix, ...args);
            return;
        }

        if (severity === LogSeverity.DEBUG) {
            console.debug(prefix, ...args);
            return;
        }

        if (severity === LogSeverity.INFO) {
            console.info(prefix, ...args);
            return;
        }

        if (severity === LogSeverity.WARNING) {
            console.warn(prefix, ...args);
            return;
        }

        console.log(prefix, ...args);
    };

    public getPrefixedCopy = (prefix: string) => {
        const consoleLogger = new ConsoleLogger();
        consoleLogger.setPrefix(prefix);
        return consoleLogger;
    };

    public getPrefix(severity: LogSeverity) {
        let customPrefix: string = '';

        if (this.prefix.length) {
            customPrefix = `[${this.prefix}]`;
        }
        return `%c[${severity.toUpperCase()}]${customPrefix}`;
    }

    public setPrefix(prefix: string) {
        this.prefix = prefix;
    }

    public debug = (...args: any[]) => {
        this.log(LogSeverity.DEBUG, ...args);
    };

    public error = (...args: any[]) => {
        this.log(LogSeverity.ERROR, ...args);
    };


    public info = (...args: any[]) => {
        this.log(LogSeverity.INFO, ...args);
    };

    public notice = (...args: any[]) => {
        this.log(LogSeverity.NOTICE, ...args);
    };

    public warning = (...args: any[]) => {
        this.log(LogSeverity.WARNING, ...args);
    };

    private getSeverityStyleString = (severity: LogSeverity): string => {
        let severityStyle: string = '';

        switch (severity) {
            case LogSeverity.INFO:
                severityStyle = 'background: #A3E6FF; color:black';
                break;
            case LogSeverity.ERROR:
                severityStyle = 'background: #C32F0D; color:white';
                break;
            case LogSeverity.NOTICE:
                severityStyle = 'background: #FAF1DC; color:black';
                break;
            case LogSeverity.WARNING:
                severityStyle = 'background: orange; color:black';
                break;
            case LogSeverity.DEBUG:
            default:
                severityStyle = 'background: gray; color:white';
        }

        return severityStyle;
    };
}

export default new ConsoleLogger();
